import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, CheckCircle2, ArrowRight, ChevronDown, ChevronUp } from "lucide-react";
import { money, Overline } from "./singleUtils";

const SEVERITY = {
  1: "border-l-rose-500 bg-rose-500/[0.05] text-rose-700 dark:text-rose-400",
  2: "border-l-amber-500 bg-amber-500/[0.06] text-amber-700 dark:text-amber-400",
  3: "border-l-indigo-500 bg-indigo-500/[0.05] text-indigo-700 dark:text-indigo-400",
};

const AttentionStrip = ({ items }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const list = items || [];
  if (list.length === 0) {
    return (
      <div className="rounded-md border border-emerald-500/25 bg-emerald-500/[0.05] px-3.5 py-2 flex items-center gap-2" data-testid="needs-attention-clear">
        <CheckCircle2 className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
        <span className="text-xs font-medium text-emerald-700 dark:text-emerald-400">All clear — nothing needs your attention</span>
      </div>
    );
  }
  const visible = expanded ? list : list.slice(0, 6);
  return (
    <div className="rounded-md border border-border bg-card" data-testid="needs-attention-alert-strip">
      <div className="flex items-center justify-between px-3.5 pt-2.5 pb-2 border-b border-border/60">
        <div className="flex items-center gap-1.5">
          <AlertTriangle className="w-3.5 h-3.5 text-rose-500" />
          <Overline className="text-foreground/70">Needs Attention</Overline>
          <span className="text-[10px] font-bold font-mono px-1.5 py-0.5 rounded-sm bg-rose-500/10 text-rose-600 dark:text-rose-400">{list.length}</span>
        </div>
        {list.length > 6 && (
          <button onClick={() => setExpanded((v) => !v)} className="text-[11px] text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid="attention-toggle">
            {expanded ? <>Less <ChevronUp className="w-3 h-3" /></> : <>All {list.length} <ChevronDown className="w-3 h-3" /></>}
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-px bg-border/40 rounded-b-md overflow-hidden">
        {visible.map((a) => (
          <button
            key={a.type}
            onClick={() => navigate(a.link)}
            className={`flex items-center justify-between gap-2 border-l-2 bg-card px-3 py-2 text-left transition-colors hover:brightness-[1.03] ${SEVERITY[a.severity] || SEVERITY[3]}`}
            data-testid={`attention-${a.type}`}
          >
            <div className="min-w-0">
              <p className="text-xs font-semibold"><span className="font-mono">{a.count}</span> <span className="font-medium">{a.label}</span></p>
              {a.amount ? <p className="text-[10px] opacity-75 font-mono">{money(a.amount)} outstanding</p> : null}
            </div>
            <ArrowRight className="w-3.5 h-3.5 shrink-0 opacity-50" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default AttentionStrip;
